<template>
	<div>
		<el-dialog title="派工/改派" :visible.sync="dialogVisible" width="680px">
			<el-form :rules="rules" ref="ruleForm" :model="formData" label-width="120px">
				<el-form-item label="承运商" prop="carrierNo">
					<el-select v-model="formData.carrierNo" @change="carrierChangeFun" placeholder="请选择承运商">
						<el-option v-for="item in partnershipList" :key="item.partnershipId" :label="item.partnerName" :value="item.partnershipId"></el-option>
					</el-select>
				</el-form-item>
        <el-form-item label="回收人员" prop="recoveryWorker">
					<el-select v-model="formData.recoveryWorker" filterable  placeholder="请选择回收人员">
						<el-option v-for="item in driverNameList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="城市">
					<span>{{ formData.province }}{{ formData.city }}{{ formData.county }}</span>
				</el-form-item>
				<!-- <el-form-item label="京东仓库">
					<span>{{ jdStoreStr }}</span>
				</el-form-item>
				<el-form-item label="仓库地址">
					<span>{{ jdStoreAddStr }}</span>
				</el-form-item> -->
				<el-form-item label="回收数量">
					<span>{{ formData.orderCount }}</span>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="confirmBtnFun" :loading="submitFlag">提 交</el-button>
				<el-button @click="cancelBtnFun">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			formData: {
				carrierNo: undefined,
				carrierName: undefined,
				province: undefined,
				city: undefined,
				county: undefined,
				address: undefined,
				contactName: undefined,
				contactMobile: undefined,
				stationId: undefined,
				stationName: undefined,
				orderCount: 0
			},
			rules: {
				carrierNo: [{ required: true, message: '请选择', trigger: 'blur' }],
				recoveryWorker: [{ required: true, message: '请选择', trigger: 'blur' }]
			},
			partnershipList: [],
			driverNameList: [],
			submitFlag: false
		}
	},
	computed: {
		// 京东仓库
		jdStoreStr () {
			const {stationId, stationName} = this.formData
			return `${stationId} ${stationName}`
		},
		// 仓库地址
		jdStoreAddStr () {
			let {province = '', city = '', county = '', address = '', contactName = '', contactMobile = ''} = this.formData
			province = province != null ? province : ''
			city = city != null ? city : ''
			county = county != null ? county : ''
			address = address != null ? address : ''
			contactName = contactName != null ? contactName : ''
			contactMobile = contactMobile != null ? contactMobile : ''
			return `${province} ${city} ${county} ${address} ${contactName} ${contactMobile}`
		}
	},
	methods: {
		// 打开弹框
		opendDialog (rowData) {
			console.log('====rowData', rowData)
			const carrierNo = parseInt(rowData.carrierNo)
			const recoveryWorker = rowData.recoveryWorker ? parseInt(rowData.recoveryWorker) : ''
			this.formData = Object.assign({}, this.formData, rowData, { carrierNo, recoveryWorker })
			// console.log('===this.formData', this.formData)
			this.dialogVisible = true
			this.getCarrierListFun()
			if (this.formData.carrierNo) {
				this.getEngineerList()
			}
		},
		// 取消弹框
		cancelBtnFun() {
			this.dialogVisible = false
		},
		// 确认
		confirmBtnFun() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					this.dispatchFun()
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		// 派工改派逻辑
		dispatchFun () {
			this.submitFlag = true
			const url = '/autoapp-default-server-recovery/api/jd/recycle/assignRecycle'
			const recycleNo = this.formData.recycleNo
			const carrierNo = this.formData.carrierNo
			const carrierItem = this.partnershipList.find((item) => item.partnershipId == carrierNo) || {}
			const carrierName = carrierItem.partnerName || ''
			const carrierOrg = carrierItem.org || ''
			const recoveryWorker = this.formData.recoveryWorker
			const recoveryItem = this.driverNameList.find((item) => item.id == recoveryWorker) || {}
			const recoveryWorkerName = recoveryItem.name || ''
			const recoveryWorkerPhone = recoveryItem.phone || ''
			const params = {
				recycleNo,
				carrierNo,
				carrierName,
				carrierOrg,
				recoveryWorker,
				recoveryWorkerName,
				recoveryWorkerPhone
			}
			// console.log('===params===', params)
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					this.$message.success('派车改派成功')
					this.$emit('dispatch-success')
					this.dialogVisible = false
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
				this.submitFlag = false
			})
		},
		// 获取承运商列表
		getCarrierListFun () {
			const url = '/autoapp-default-server-recovery/api/jd/partnerManagementBond/pageJdPartnerShip'
			const params = {
				currPage: 1,
				pageSize: 999999
			}
			this.HttpService.post(url, params).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					this.partnershipList = res.data || []
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		},
		// 承运商改变
		carrierChangeFun (val) {
			this.formData.recoveryWorker = undefined
			if (val) {
				this.getEngineerList()
			}
		},
		// 获取承运商下回收人员
		getEngineerList () {
			const url = `/autoapp-default-server-recovery/api/oldMachineRecovery/findEngineerByOrgId/${this.formData.carrierNo}`
			this.HttpService.post(url).then(res => {
				if (res.statusCode === 200) {
					// console.log('res===', res)
					const resData = res.data || []
					this.driverNameList = resData
				} else {
					const msgTip = res.message || '请求出错'
					this.$message.error(msgTip)
				}
			})
		}
	},
}
</script>
<style scoped lang="scss">
.dialog-footer {
	padding: 16px;
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/jdOldMachineRecycleManage/components/AssignVehiclesDialog.vue